import { TValidTestId } from 'types/context-role-element.types';
import { CONTEXT, ELEMENT, ROLE } from '../../context-role-element';

export default {
  [CONTEXT.CONFIRM_EMAIL_PAGE]: {
    [ROLE.CONTAINER]: [ELEMENT.RETRY, ELEMENT.LOGIN, ELEMENT.SUCCESS_FEEDBACK],
    [ROLE.BUTTON]: [ELEMENT.GO_HOME],
  },
} as TValidTestId;
